var render = function (_h,_vm) {
var _obj;
var _c=_vm._c;return _c('h2',{staticClass:"headline",class:( _obj = {}, _obj['mt-3 mb-2'] = !_vm.data.staticClass, _obj[_vm.data.staticClass] = !!_vm.data.staticClass, _obj )},[_vm._t("default",[_vm._v(_vm._s(_vm.parent.$t(_vm.props.title)))])],2)}
var staticRenderFns = []

export { render, staticRenderFns }